export default {
  product: {
    productId: 'Headquarters SPU ID',
    skuId: 'Headquarters SKU ID',
    hqSpuId: 'Headquarters SPU ID',
    hqSkuId: 'Headquarters SKU ID',
    shopSpuId: 'Store SPU ID',
    shopSkuId: 'Store SKU ID',
    copy: 'Copy',
    copySuccess: 'Copied successfully!',
    copyFail: 'Copy failed, please copy manually',
  },
  productClass: {
    changeCategory: 'Change Category',
    sourceCategoryTip: 'Source category: {name}, {count} products. Select the products to move and choose a different target category.',
    targetCategory: 'Move to Backend Category',
    targetCategoryRequired: 'Select a leaf backend category other than the source category',
    changeCategorySuccess: 'Product categories changed successfully',
    batchChangeCategoryConfirm: 'Move the {count} selected products to the “{name}” category?',
    Association: 'Associate Products',
    associatedProductCount: 'Associated Products',
    associationDialogTitle: 'Associate Products with “{name}”',
    associatedDialogTitle: 'Products Associated with “{name}”',
    selectedProductCount: '{count} products selected',
    selectAtLeastOneProduct: 'Select at least one unassociated product',
    batchAssociateConfirm: 'Associate the {count} selected products with this category?',
    associationSuccess: 'Products associated successfully',
    unbind: 'Unbind',
    batchUnbind: 'Batch Unbind',
    unbindConfirm: 'Unbind “{productName}” from this category?',
    batchUnbindConfirm: 'Unbind the {count} selected products from this category?',
    unbindSuccess: 'Product unbound successfully',
    unbindAction: 'Unbind Products',
    unbindResultTitle: 'Unbinding Results',
    unbindResultCategory: 'Category: {name}',
    unbindResultSuccess: 'Successfully unbound {count} products: {names}',
    unbindResultFailed: 'Failed to unbind {count} products',
    unbindResultFailureTip: 'These products could not be unbound. Please review their details.',
    unbindResultEmpty: 'No product unbinding results were returned. Please refresh the category to check its associations.',
    unbindResultEditProduct: 'Edit Product',
    unbindResultAcknowledge: 'Got It',
    unbindSelectTip: 'Select at least one product to unbind',
    selectedCategoryTip: 'Selected category: {name}, {count} associated products',
    selectedCountWithMax: '{count} selected / up to {max} products',
    maxSelectTip: 'You can select up to {max} products',
    cancelSelectionConfirm: 'The current product selection is not saved. Cancel and discard these changes?',
    continueCancel: 'Continue Canceling',
    returnSelect: 'Return to Selection',
    mnemonicCode: 'Mnemonic Code',
    productName: 'Product Name',
    productCode: 'Product Code',
    productContent: 'Product Content',
    productType: 'Product Type',
    backendCategory: 'Backend Category',
    frontendCategory: 'Frontend Category',
    saleStatus: 'Sale Status',
    availableForSale: 'Available',
    unavailableForSale: 'Unavailable',
    alreadyAssociated: 'Associated',
    associationStatus: 'Association Status',
  },
  productStock: {
    productList: 'Product List',
    inventoryAdjustmentRecord: 'Inventory Adjustment Records',
    stockMovementRecord: 'Stock Movement Records',
    productSummary: 'Product Summary',
    shopDetail: 'Store Details',
    viewMode: 'View',
    productName: 'Product Name',
    productContent: 'Product Content',
    hqSkuId: 'Headquarters SKU ID',
    specificationCode: 'Store SKU ID',
    shopName: 'Store Name',
    productType: 'Product Type',
    shopCount: 'Store Count',
    stockDistribution: 'Stock Status Distribution',
    currentStock: 'Current Stock',
    dailyRestock: 'Daily Restock Quantity',
    dailyRestockValue: '{count} Daily',
    stockStatus: 'Stock Status',
    detail: 'Details',
    stockDetail: 'Stock Details',
    storeStock: 'Store Stock',
    adjustStock: 'Adjust Stock',
    stockAdjustment: 'Stock Adjustment',
    adjustmentMethod: 'Adjustment Method',
    increaseStock: 'Increase Stock',
    decreaseStock: 'Decrease Stock',
    adjustmentQuantity: 'Quantity',
    batchIncreaseStock: 'Batch Increase Stock',
    increaseQuantity: 'Increase Quantity',
    selectedProducts: '{count} products selected',
    batchIncreaseSuccess: 'Stock increased successfully',
    confirmAdjustment: 'Confirm Adjustment',
    confirmAdjustmentTitle: 'Confirm Stock Adjustment',
    stockSettings: 'Stock Settings',
    autoRestock: 'Daily Fixed Quantity',
    autoRestockTip: 'Automatically replenish stock to the set quantity each day',
    restockQuantity: 'Daily Replenishment Quantity',
    stockThreshold: 'Low Stock Threshold',
    stockThresholdPlaceholder: 'Enter the low stock threshold',
    saveSettings: 'Save Settings',
    discardChangesTitle: 'Discard changes?',
    discardChangesMessage: 'Your unsaved changes will be lost if you close this dialog.',
    continueEditing: 'Continue Editing',
    discardChanges: 'Discard Changes',
    insufficientStock: 'The decrease quantity cannot exceed the current stock',
    all: 'All',
    soldOut: 'Sold Out',
    lowStock: 'Low Stock',
    normal: 'Normal',
    countTicket: 'Count Ticket',
    timeTicket: 'Time Ticket',
    enabled: 'Enabled',
    disabled: 'Disabled',
    changeType: 'Change Type',
    changeCount: 'Change Quantity',
    beforeStock: 'Stock Before',
    afterStock: 'Stock After',
    sourceNo: 'Related Document No.',
    remark: 'Remarks',
    operator: 'Operator',
    operationSource: 'Operation Source',
    clientSystem: 'System',
    clientAdmin: 'Admin Portal',
    clientApp: 'APP',
    clientCashier: 'Cashier',
    clientMiniProgram: 'Mini Program',
    systemOperator: 'System',
    projectDeductionNo: 'Project Deduction No.',
    afterSalesNo: 'After-sales No.',
    salesOrderNo: 'Sales Order No.',
    operationTime: 'Operation Time',
    dailyStockReplenishment: 'Daily Stock Replenishment',
    manualDecrease: 'Manual Decrease',
    manualIncrease: 'Manual Increase',
    salesDecrease: 'Sales Decrease',
    refundReplenishment: 'Refund Replenishment',
  },
};
